module.exports = __webpack_public_path__ + "static/media/L9.92a7de01.jpg";